// Dev/review-only one-click login for seeded accounts, on the legacy login
// page only (the redesigned page renders the React dev kit from LoginCard
// instead - see login.ts). The widget is rendered only on dev sites
// (see app/views/pages/_dev_login_panel.html.erb); this module no-ops when it
// is absent, so it is safe to call on every legacy login page load. Floating
// placement and collapse are owned by the shared dev kit shell
// (app/views/shared/_dev_kit_panel.html.erb), so all this does is fill and
// submit. There is deliberately no session-creation endpoint here: the panel
// fills the normal Devise form and submits it, so lockout, 2FA and audit hooks
// all still apply.

import { setNativeFieldValue } from '@/utils/setNativeFieldValue';

// Signals the server (after_sign_in_path_for) to ignore any stale stored
// location so one-click login always lands on the tester's own dashboard.
function ensureDevLoginFlag(form: HTMLFormElement): void {
  let field = form.querySelector<HTMLInputElement>('input[name="dev_login"]');
  if (!field) {
    field = document.createElement('input');
    field.type = 'hidden';
    field.name = 'dev_login';
    form.appendChild(field);
  }
  field.value = '1';
}

export function initDevLoginPanel(): void {
  const panel = document.querySelector<HTMLElement>('[data-dev-login-panel]');
  if (!panel) return;

  const select = panel.querySelector<HTMLSelectElement>('[data-dev-login-select]');
  const submit = panel.querySelector<HTMLButtonElement>('[data-dev-login-submit]');
  const form = document.querySelector<HTMLFormElement>('#new_session');
  if (!select || !submit || !form) return;

  const password = panel.dataset.devLoginPassword ?? '';

  submit.addEventListener('click', () => {
    // The email form starts collapsed until "Continue with email" is clicked;
    // reveal it (only when hidden) so the filled form is visible as it submits.
    const continueWithEmail = document.getElementById('continue-with-email');
    if (continueWithEmail && form.style.maxHeight === '0px') {
      continueWithEmail.click();
    }

    ensureDevLoginFlag(form);
    setNativeFieldValue(form, 'user[email]', select.value);
    setNativeFieldValue(form, 'user[password]', password);

    form.querySelector<HTMLElement>('input[type="submit"], button[type="submit"]')?.click();
  });
}
